export enum EstadosEfectivo {
  EnProceso = 140,
  RequiereInformacion = 141,
  Disponible = 142,
  Finalizada = 143,
  Rechazada = 144,
  Cancelada = 145,
}

export enum EstadosCheque {
  EnProceso = 146,
  RequiereInformacion = 147,
  Disponible = 148,
  Finalizada = 149,
  Rechazada = 150,
  Cancelada = 151,
}

export enum EstadosECheq {
  EnProceso = 152,
  RequiereInformacion = 153,
  Disponible = 154,
  Finalizada = 155,
  Rechazada = 156,
  Cancelada = 157,
}

export enum EstadosTransferencia {
  EnCurso = 158,
  Fallida = 159,
  Finalizada = 160,
  Cancelada = 161,
}

export enum EstadosTransferenciaProgramada {
  Programada = 162,
  EnRevision = 163,
  Finalizada = 164,
  Rechazada = 165,
  Cancelada = 166,
}

export enum EstadosTransferenciaExterna {
  Pendiente = 222,
  Fallida = 225,
  Finalizada = 229,
}

export enum EstadosOrdenVenta {
  EnProceso = 167,
  EnComunicacion = 168,
  Confirmada = 169,
  Rechazada = 170,
  Cancelada = 171,
  Negociacion = 172,
}

export enum EstadosContraEntrega {
  EnProceso = 173,
  EnComunicacion = 174,
  Confirmada = 175,
  Rechazada = 176,
  Cancelada = 177,
  Negociacion = 178,
}

export enum EstadosContratoFuturo {
  EnProceso = 179,
  EnComunicacion = 180,
  Confirmada = 181,
  Rechazada = 182,
  Cancelada = 183,
  Negociacion = 184,
}

export enum EstadosCupos {
  Pendiente = 185,
  RequiereInformacion = 186,
  CuposAsignadosParcialmente = 187,
  CuposAsignados = 188,
  Rechazada = 189,
  Cancelada = 190,
}

export enum EstadosTransferenciaDiferida {
  Finalizada = 191,
  EnCurso = 192,
  Cancelada = 193,
}

export enum EstadosChequesRespaldo {
  PendienteDeCheque = 66,
  PendienteDeEndoso = 70,
  Finalizado = 74,
  Cancelado = 78,
}

export enum EstadosSolicitudesInsumos {
  PendienteDeConfirmacion = 90,
  RequiereInformacionSolicitudInsumos = 94,
  PedidoCreado = 96,
  ConfirmadoParcial = 98,
  PedidoConfirmado = 102,
  EnCamino = 106,
  EntregaParcial = 110,
  EntregadoSolicitud = 114,
  RechazadaInsumos = 118,
  CanceladaInsumos = 122,
}

export enum EstadosPedidosInsumos {
  PendientePedido = 126,
  ConfirmadoPedido = 130,
  EnCaminoPedido = 134,
  Entregado = 138,
}

export enum EstadosIntencionCompra {
  Pendiente = 250,
  EnComunicacion = 251,
  Presentada = 252,
  Cancelada = 253,
  Rechazada = 254,
}

export enum EstadosOBJuridico {
  Precargado = 195,
  Pendiente = 196,
  EnRevision = 197,
  RequiereCambios = 198,
  Aprobado = 199,
}

export enum EstadosArchivo {
  Aceptado = 200,
  Rechazado = 201,
}

export enum EstadosSolicitudContacto {
  PendienteDeContactoSolicitudContacto = 1,
  ContactadoSolicitudContacto = 2,
  SinValidar = 30,
  NoContactar = 31,
}

export enum EstadosVisitaCampo {
  PendienteAsignacion = 255,
  Cancelada = 256,
  Rechazada = 257,
  Asignada = 258,
  Realizada = 259,
  Cerrada = 260,
}

export enum EstadosPlanificacionProductiva {
  Cargada = 270,
  Presentada = 271,
  DatosEnRevision = 272,
  Cancelada = 273,
}

export enum EstadosHistorialCargaImpuestos{
  Completada = 275,
  Error = 276,
}

export enum EstadosImpuestosBIND {
  Pendiente = 277,
  Cobrado = 278,
  Error = 279,
}

export enum EstadosSolicitudServicio {
  Pendiente = 280,
  Cancelada = 281,
  Rechazada = 282,
  Realizado = 283,
  Cerrado = 284,
}

export enum EstadosSolicitudMargenBruto {
  EnProceso = 286,
  Pendiente = 285,
  Confirmada = 287,
  Cancelada = 288,
  Rechazada = 299,
}

export enum EstadosSolicitudEstablecimiento {
  Pendiente = 295,
  Confirmada = 296,
  Rechazada = 297,
  Cancelada = 298
}